

















































































































































































































































import { Component, Watch } from "vue-property-decorator";
import Items from "./Items";
import RadioButtonBox from "@/components/elements/utility/RadioButtonBox.vue";
import AccordionSection from "@/components/elements/accordion/AccordionSection.vue";
import { LineItem, LineItemRecord, Note } from "@/models/order/order";
import { ProductType } from "@/models/products/product";
import * as option from "@/models/configurator/configurator_options";
import AddToQuoteFooter from "@/components/footer/AddToQuoteFooter.vue";
import ProductService from "@/services/product_service";
import { FabricComponent } from "@/models/configurator/fabric_components";
import FabricSelector from "@/components/items/fabric_picker/FabricSelector.vue";
import MiniSwatch from "@/components/elements/products/MiniSwatch.vue";
import { CustomChairOrder } from "@/models/configurator/custom_umbrella";
import { FabricSwatch } from "@/models/products/fabric";
import { ChairNames } from "@/models/products/collection";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import { ChairModel } from "@/models/products/chair";
import { EventBus } from "@/event-bus";
import { NoteFields } from "@/models/order/helpers";
import Dropdown from "@/components/elements/utility/Dropdown.vue";
import SpecsModal from "@/components/elements/modal/SpecsModal.vue";
import { AuthError, GenericError } from "@/services/error_service";
import { ChairPrice, PriceRes } from "@/models/pricing/price";
import { formatTitle } from "@/utility/helpers";
import order from "@/store/modules/order";
import { GlobalActions } from "@/store/modules/global/types";
import { PriceLevel } from "@/models/netsuite/netsuite";
import { StoreModule } from "@/store/types";
import { namespace } from "vuex-class";

@Component({
  components: {
    AccordionSection,
    RadioButtonBox,
    AddToQuoteFooter,
    FabricSelector,
    MiniSwatch,
    FormValidation,
    Dropdown,
    SpecsModal
  }
})
export default class CustomizeChair extends Items {
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;

  protected formatTitle = formatTitle;
  protected ChairNames = ChairNames;
  protected selected: ChairModel | null = null;
  protected index: null | number = 0;
  protected ProductType = ProductType;
  protected model = "";
  protected option = option;
  protected swatch: FabricSwatch | null = null;
  protected displayName = "";
  protected whiteFabric: FabricSwatch = {
    brand: {
      name: "Recacril",
      handle: "recacril",
      mfr: { name: "Recasens", handle: "recasens" }
    },
    color_group: ["White"],
    comparisons: ["4604", "5409"],
    fabric_scale: 1,
    fabric_type: "acrylic",
    grade: "a",
    image: "16-WHA.jpg",
    index: 0,
    mfr_code: "R-099",
    name: { group: null, color: "White", display: "White" },
    pattern_group: ["Solids"],
    _id: "60b006995119130a58a7b0e8"
  };
  protected item_details: CustomChairOrder = {
    mainFabric: null!,
    bindingFabric: this.whiteFabric,
    foldOver: false,
    notes: []
  };
  protected noteObj = {
    model: "",
    fabric: ""
  };
  protected showNoteModal = {
    model: false,
    fabric: false
  };
  protected productService = new ProductService();
  protected itemPrice = 0;
  protected sku = "";
  protected FabricComponent = FabricComponent;
  protected component: FabricComponent | null = null;
  protected fabricSelectorVisible = false;
  protected showSpecsModal = false;
  protected priceDoc: PriceRes | null = null;

  /** ALl custom validations should evaluate to true to submit form. Invalid = false */
  @Validations()
  validations() {
    return {
      item_details: {
        mainFabric: { required }
      }
    };
  }

  @Watch("item_details.mainFabric")
  private checkMainFabric(): void {
    if (this.item_details.foldOver) {
      this.foldOverFabric();
    }
  }

  @Watch("model")
  private async onModelChange(): Promise<void> {
    if (this.model) {
      await this.getPrice();
      await this.updateSKU();
    }
  }

  @Watch("item_details.mainFabric")
  private async onMainFabricChange(): Promise<void> {
    await this.updateSKU();
  }

  @Watch("item_details.bindingFabric")
  private async onBindingFabricChange(): Promise<void> {
    await this.updateSKU();
  }

  async created() {
    if (!this.$route.params.edit && this.$route.query.cart) {
      // if a user refreshes or back buttons onto this page, redirect to expired notice. because we are using index to update item, the user must navigate directly from the cart, or we can't guarantee the index is correct
      this.$router.replace("/resubmit");
    } else if (this.$route.params.edit && this.$route.query.cart) {
      await this.getItems(this.product, this.handle);
      this.editMode = true;
      const index = parseInt(this.$route.query.cart as string, 10);
      await this.prepDataForEdit(index);
    } else {
      await this.getItems(this.product, this.handle);
      await this.setDefaults();
    }
    await this.getPrice();
    await this.updateSKU();
    this.$emit("ready");
  }

  protected async foldOverFabric(): Promise<void> {
    if (!this.priceDoc) {
      await this.getPrice();
    }
    if (
      this.item_details.foldOver &&
      this.item_details.mainFabric.mfr_code !== this.whiteFabric.mfr_code
    ) {
      this.item_details.bindingFabric = this.item_details.mainFabric;
      this.itemPrice = this.priceDoc!.ap!;
    } else {
      this.item_details.bindingFabric = this.whiteFabric;
      this.itemPrice = this.priceDoc!.a!;
    }
  }

  protected async prepDataForEdit(index: number): Promise<void> {
    this.item_details = Object.assign(
      {},
      { ...this.storeItems[index].item_details }
    ) as CustomChairOrder;
    if (!this.item_details.mainFabric.mfr_code) {
      this.item_details.mainFabric = await this.getFabricObject(
        this.item_details.mainFabric as any
      );
    }
    if (
      this.item_details.bindingFabric &&
      !this.item_details.bindingFabric.mfr_code
    ) {
      this.item_details.bindingFabric = await this.getFabricObject(
        this.item_details.bindingFabric as any
      );
    }
    this.model = this.storeItems[index].model;
    this.selected = this.items.find(item => item.model === this.model);
    if (this.item_details.notes && this.item_details.notes.length > 0) {
      this.setNotes();
    } else {
      this.item_details.notes = [];
    }
  }

  protected setNotes(): void {
    const cf = ["model", "fabric"];
    cf.forEach(field => {
      const obj = this.item_details.notes!.find(e => e.field === field);
      if (obj) {
        this.noteObj[field] = obj.content;
      }
    });
  }

  protected addNotesToQuote(): void {
    this.item_details.notes = [];
    for (const [key, value] of Object.entries(this.noteObj)) {
      this.item_details.notes.push({
        field: key as NoteFields,
        content: value
      });
    }
  }

  protected closeSpecsModal(): void {
    this.showSpecsModal = false;
  }

  protected toggleSpecsModal(): void {
    this.showSpecsModal = true;
  }
  protected async setDefaults(): Promise<void> {
    this.selected = this.items[0];
    this.model = this.selected!.model;
    const defaults = await this.getProductLineInfo();
    this.displayName = defaults.display_name;
  }

  protected async updateSKU(): Promise<void> {
    if (
      !this.model ||
      !this.item_details.mainFabric ||
      !this.item_details.bindingFabric
    ) {
      return;
    }
    /**
     * Encode a fabric reference for the SKU pipeline.
     * Returns "<mfr_code>::<brand_collection_name>" when the fabric carries a
     * brand_collection (used by the API to disambiguate duplicate mfr_codes
     * across SENS collections), or just "<mfr_code>" otherwise.
     */
    const encodeFabric = (f: FabricSwatch): string => {
      const collection = f.brand && f.brand.brand_collection && f.brand.brand_collection.name;
      return collection ? `${f.mfr_code}::${collection}` : f.mfr_code;
    };
    this.sku = await this.productService.createChairSKU({
      chair: {
        model: this.model,
        mainFabric: encodeFabric(this.item_details.mainFabric),
        bindingFabric: encodeFabric(this.item_details.bindingFabric)
      }
    });
  }

  protected async getPrice(): Promise<void> {
    try {
      const price = await this.productService.getPriceDoc(this.model);
      this.priceDoc = price;
      await this.foldOverFabric();
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      }
      GenericError.popup(err.message);
    }
  }

  protected addToQuote(item: LineItem) {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.addNotesToQuote();
      const orderItem = { ...item, item_details: this.item_details };
      orderItem.sku = this.sku;
      this.addItem(orderItem);
      const numberPrice =
        orderItem.unit_price * orderItem.multiplier * orderItem.qty;
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        cost: numberPrice,
        name: orderItem.display_name,
        fabric: [this.item_details.mainFabric],
        model: orderItem.model,
        sku: this.sku
      });
      this.editMode = true;
    }
  }

  protected editQuote(item: LineItem) {
    const index = parseInt(this.$route.query.cart as string, 10);
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.addNotesToQuote();
      // The footer's lineItem doesn't carry NetSuite line identity
      // (ns_line_id, ns_locked). Merge the edited fields onto the original
      // stored line so a NetSuite-added/linked line keeps its identity and is
      // still recognized as an update — not a brand-new line — on resubmit.
      const original = this.storeItems[index];
      const orderItem = {
        ...original,
        ...item,
        item_details: this.item_details
      };
      orderItem.sku = this.sku;
      this.editLineItem({ item: orderItem, index: index });
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        name: orderItem.display_name,
        fabric: [this.item_details.mainFabric],
        model: orderItem.model,
        sku: this.sku
      });
    }
  }

  protected toggleModal(field: string): void {
    this.showNoteModal[field] = true;
  }

  protected closeModal(): void {
    this.showNoteModal = {
      model: false,
      fabric: false
    };
  }

  protected showFabricSelector(
    selection: FabricComponent,
    swatch: FabricSwatch,
    index = null
  ): void {
    this.$v.$reset();
    this.swatch = swatch;
    this.index = index;
    this.component = selection;
    this.fabricSelectorVisible = true;
  }

  protected changeSelectedModel(item: ChairModel): void {
    this.selected = item;
  }

  get chairs(): ChairModel[] {
    return this.items as ChairModel[];
  }
}
